import { useMemo } from 'react';
import { useRouteMatch } from 'react-router';
import { routes } from '@/core/router/routes';
import { RouteDeclaration, Routes } from '@/core/router/routes.types';
import { useGetUserQuery } from '@/services/innovorder/user/user.endpoints';
import { UserRoles } from '@/services/innovorder/user/user.type';

interface UseUserTabRoutesReturn {
    tabRoutes: RouteDeclaration[];
    isLoadingTargetUser: boolean;
}

/**
 * Returns filtered user tab routes based on the target user's role.
 * The "Restaurants associés" tab is only shown for restaurant users,
 * since brand users already have access to all restaurants in their brand.
 */
export const useUserTabRoutes = (): UseUserTabRoutesReturn => {
    const { params } = useRouteMatch<{ userId: string }>();
    const userId = Number(params.userId);

    const { data: targetUser, isLoading } = useGetUserQuery({ userId });

    const tabRoutes = useMemo(() => {
        const userTabs = routes.filter(({ tab }) => tab === 'user');

        // Only show the UserRestaurants tab for restaurant users
        // Brand users already have access to all restaurants
        if (targetUser && targetUser.role !== UserRoles.restaurant) {
            return userTabs.filter(({ path }) => path !== Routes.UserRestaurants);
        }

        return userTabs;
    }, [targetUser]);

    return { tabRoutes, isLoadingTargetUser: isLoading };
};
